const normalizeWalletType = (type) => {
  const normalizedType = String(type || "").trim().toLowerCase();
  if (normalizedType === "stablecoin" || normalizedType === "stable-token") {
    return "stable-token";
  }
  if (normalizedType === "coin" || normalizedType === "token") {
    return normalizedType;
  }
  return "token";
};

export const transformWalletData = (data, walletType) => {
  if (!data) return [];
  
  if (walletType === "Virtual") {
    // Use virtual wallet coins from Redux state (coinList1)
    const virtual = data.virtual || [];
    return virtual.map(item => {
      const coinType = item.symbol || item.coin_type || "N/A";
      // For virtual wallet, balance is already in USD
      const price = parseFloat(item.coin_price || item.price || 0);
      const balance = parseFloat(item.quantity || item.balance || 0) * price;
      const qty = parseFloat(item.quantity || item.balance || 0);
      return {
        symbol: coinType,
        type: normalizeWalletType(item.type),
        balance: balance,
        qty: qty,
        price: price,
      };
    });
  } else if (walletType === "On-chain") {
    const onchain = data.onchain?.[0]?.topBalances || [];
    return onchain.map(item => {
      const coinType = item.coin_type || item.symbol || "N/A";
      const balance = parseFloat(item.balance || 0);
      const price = parseFloat(item.coin_price || 0);
      return {
        symbol: coinType,
        type: normalizeWalletType(item.type),
        balance: balance * price,
        qty: balance,
        price: price,
      };
    });
  }
  return [];
};

export const transformBankData = (data) => {
  if (!data) return [];
  // Bank wallet uses topThreeCoins array
  const balances = data.topThreeCoins || data.topBalances || data.balances || [];
  return balances.map(item => ({
    currency: item.currency || item.symbol || "N/A",
    balance: parseFloat(item.balanceUSD || item.balance || 0),
    qty: parseFloat(item.balance || 0),
  }));
};

export const transformVirtualWalletData = (virtualWalletCoins) => {
  if (!virtualWalletCoins || virtualWalletCoins.length === 0) return [];
  
  return virtualWalletCoins.map(item => {
    const coinType = item.symbol || "N/A";
    const price = parseFloat(item.coin_price || item.price || 0);
    const qty = parseFloat(item.quantity || item.balance || 0);
    const balance = parseFloat(item.balance || (qty * price) || 0);
    return {
      symbol: coinType,
      type: normalizeWalletType(item.type),
      balance: balance,
      qty: qty,
      price: price,
      contract_address: item.contract_address || item.contractAddress || item.address || null,
      chain_id: item.chain_id || item.chainId || null,
    };
  });
};

export const transformOnchainWalletData = (onchainWalletData) => {
  if (!onchainWalletData || onchainWalletData.length === 0) return [];
  
  const transformed = onchainWalletData.map(item => {
    const coinType = item.symbol || "N/A";
    const price = parseFloat(item.coin_price || item.price || 0);
    const qty = parseFloat(item.quantity || 0);
    const balance = qty * price;
    return {
      symbol: coinType,
      type: normalizeWalletType(item.type),
      balance: balance,
      qty: qty,
      price: price,
    };
  });

  const uniqueMap = new Map();
  
  transformed.forEach(item => {
    const existing = uniqueMap.get(item.symbol);
    if (existing) {
      existing.qty += item.qty;
      existing.balance += item.balance;
      if (item.price > 0 && existing.price === 0) {
        existing.price = item.price;
      } else if (item.price > 0 && existing.price > 0) {
        existing.price = (existing.price + item.price) / 2;
      }
    } else {
      uniqueMap.set(item.symbol, { ...item });
    }
  });

  return Array.from(uniqueMap.values());
};

export const getCategoryTotals = (items) => ({
  coins: items.filter((a) => a.type === "coin").reduce((acc, a) => acc + a.balance, 0),
  tokens: items.filter((a) => a.type === "token").reduce((acc, a) => acc + a.balance, 0),
  stableTokens: items.filter((a) => a.type === "stable-token").reduce((acc, a) => acc + a.balance, 0),
});

